var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('router-link', {
      key: tab.id,
      staticClass: "s-tab",
      class: {
        'active-tab': _vm.$route.name === tab.route
      },
      attrs: {
        "to": {
          name: tab.route
        }
      }
    }, [_vm._v(" " + _vm._s(tab.name) + " ")]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }